module.exports = __webpack_public_path__ + "static/flipkart_logo-90b37e0f925353909546aab0f58c3cc2.png";